angular.module('zc.zenclerkS')
  .factory('ZcsDeviceName', ZcsDeviceName);

ZcsDeviceName.$inject = ['$translate'];
function ZcsDeviceName($translate) {
  const service = {
    getDeviceName,
    getDeviceNames,
  };

  const deviceNames = {
    devicefree: $translate.instant('services.deviceName.devicefree'),
    pc: $translate.instant('services.deviceName.pc'),
    sp: $translate.instant('services.deviceName.sp'),
    tablet: $translate.instant('services.deviceName.tablet'),
  };

  return service;

  function getDeviceName(device) {
    return _.get(deviceNames, device, device);
  }

  function getDeviceNames() {
    return deviceNames;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/device_name.service.js